import { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

export const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};
